import { render, staticRenderFns } from "./SidebarCompanySelect.vue?vue&type=template&id=64abcf10&scoped=true"
import script from "./SidebarCompanySelect.vue?vue&type=script&lang=js"
export * from "./SidebarCompanySelect.vue?vue&type=script&lang=js"
import style0 from "./SidebarCompanySelect.vue?vue&type=style&index=0&id=64abcf10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64abcf10",
  null
  
)

export default component.exports